export default __webpack_public_path__ + "public/assets/images/f5785bbbd1a76251c24bebd6341cdb59.png";